import { render, staticRenderFns } from "./MomentToMomentRatings.vue?vue&type=template&id=02218b42&"
import script from "./MomentToMomentRatings.vue?vue&type=script&lang=ts&"
export * from "./MomentToMomentRatings.vue?vue&type=script&lang=ts&"
import style0 from "./MomentToMomentRatings.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports